/** The «Yuma on the site» console page (30/10/2026): yumaos.com visitors' conversations with Yuma. */
export default {
  titolo: 'Yuma on the site',
  sottotitolo:
    'Conversations between yumaos.com visitors and Yuma, as they saw them. Kept for 12 months, or forever when the person joins the waiting list.',
  aggiorna: 'Refresh',
  spesa: {
    accesa: 'Yuma is on',
    spenta: 'Yuma is off',
    oggi: 'Spent today',
    tetto: 'out of a {{tetto}} daily cap',
    trenta: 'Last 30 days',
  },
  impostazioni: {
    cambiaTetto: 'Change the cap',
    nuovoTetto: 'Daily cap, in dollars',
    salva: 'Save the cap',
    annulla: 'Cancel',
    interruttore: 'Yuma answers on the website',
    salvato: 'Setting saved.',
    errore: 'Setting not saved: {{motivo}}',
    spiegazioneTetto: 'Past the cap Yuma says she is done for today and sends visitors to the waiting list. You get an email at half and at the cap.',
  },
  filtri: {
    etichetta: 'Which conversations',
    tutte: 'All',
    con_modulo: 'Form ready',
    iscritti: 'Turned into sign-ups',
  },
  elenco: {
    vuoto: 'No conversations yet. As soon as a visitor writes to Yuma, you will find it here.',
    vuotoFiltro: 'No conversation matches this filter among those loaded.',
    altre: 'Load earlier conversations',
    senzaNome: 'Unnamed visitor',
    messaggi_one: '{{count}} message',
    messaggi_other: '{{count}} messages',
    daPagina: 'from {{pagina}}',
    paginaDiYuma: 'from the Yuma page',
  },
  stato: {
    iscritto: 'Signed up',
    modulo: 'Form ready',
  },
  dettaglio: {
    scegli: 'Pick a conversation from the list to read it.',
    indietro: 'All conversations',
    iniziata: 'Started on {{data}}',
    costo: 'Cost {{costo}}',
    scade: 'Deleted automatically on {{data}}',
    perSempre: 'Kept forever with the sign-up',
    apriIscritto: 'Open the sign-up record',
    detto: 'Spoken',
    riassunto: 'The summary Yuma wrote for us',
    caricamento: 'Loading the conversation…',
  },
  schede: {
    video: 'Video «{{slug}}», from second {{secondo}}',
    pagina: 'Page shown',
    conto: 'Quote proposed',
    mensile: 'per month',
    annuale: 'per year',
    totale: 'Total, excluding VAT',
    marchio: 'Brand read from the website',
    modulo: 'Waiting list form prepared',
    risposte_one: '{{count}} answer filled in',
    risposte_other: '{{count}} answers filled in',
  },
  iscritto: {
    titolo: 'Talked to Yuma on the website',
    apri: 'Read the conversation',
  },
  errori: {
    elenco: 'The conversations did not load: {{motivo}}',
    conversazione: 'The conversation did not load: {{motivo}}',
  },
} as const;
